import { userQueries } from "@/features/user/query";
import { authQueries } from "@/libs/auth/query";

export const queries = {
  auth: authQueries,
  user: userQueries,
};
